import * as Yup from 'yup'

export const initialValues = {
    tradeIn: false,
    selectedLocation: '',
}

export const validationSchema = Yup.object().shape({
    selectedLocation: Yup.string().required('The location is required'),
    tradeIn: Yup.bool(),
})
